<template>
  <div class="ota-usps lg:px-20">
    <div class="ota-usps-container bg-gray-50 px-10 py-5 rounded text-center">
      <div class="ota-usps-container-grid justify-center block sm:inline-grid grid-cols-2">
        <div v-for="(usp, index) in usps" :key="`${usp}${index}`" class="flex" :class="{'mb-rem': index !== usps.length - 1}">
          <OSvg class="fill-green-300 w-3 h-3 mr-2 mt-1 flex-shrink-0" svg="checkmark" />
          <span class="text-sm text-gray-600 antialiased text-left pr-3" v-html="usp" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const OSvg = () => import('@/components/OSvg')

export default {
  name: 'USPs',
  components: {
    OSvg
  },
  props: {
    usps: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
